import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import API_BASE from "./config";

// Standalone page (opened in a new tab from the Workflow Designer) that renders the
// designer tutorial markdown served by the backend (single source of truth in
// backend/docs/DESIGNER_TUTORIAL.md). remark-gfm enables tables/strikethrough/etc.
const DesignerTutorial = () => {
  const [md, setMd] = useState("Loading tutorial…");

  useEffect(() => {
    document.title = "Workflow Designer — Tutorial";
    fetch(`${API_BASE}/designer-tutorial-md`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then(setMd)
      .catch(() => setMd("Failed to load the tutorial. Please try again later."));
  }, []);

  return (
    <div className="designer-tutorial">
      <style>{`
        .designer-tutorial { max-width: 900px; margin: 0 auto; padding: 40px 24px 80px;
          line-height: 1.65; color: #0f172a;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }
        .designer-tutorial h1, .designer-tutorial h2, .designer-tutorial h3 { color: #213a22; margin-top: 1.6em; }
        .designer-tutorial h1 { border-bottom: 2px solid #e2e8f0; padding-bottom: .3em; }
        .designer-tutorial h2 { border-bottom: 1px solid #e2e8f0; padding-bottom: .25em; }
        .designer-tutorial code { background: #f1f5f9; padding: 2px 6px; border-radius: 4px;
          font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 0.9em; }
        .designer-tutorial pre { background: #1f2937; color: #f3f4f6; padding: 14px 16px;
          border-radius: 8px; overflow-x: auto; }
        .designer-tutorial pre code { background: transparent; color: inherit; padding: 0; }
        .designer-tutorial table { border-collapse: collapse; width: 100%; margin: 1em 0; }
        .designer-tutorial th, .designer-tutorial td { border: 1px solid #cbd5e1; padding: 8px 10px; text-align: left; }
        .designer-tutorial th { background: #273d3b; color: #fff; }
        .designer-tutorial tr:nth-child(even) { background: #f8fafc; }
        .designer-tutorial a { color: #2563eb; }
        .designer-tutorial blockquote { border-left: 4px solid #cbd5e1; margin: 1em 0; padding: 4px 16px; color: #475569; }
      `}</style>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown>
    </div>
  );
};

export default DesignerTutorial;
